ace.define("ace/theme/ace-queryinput", ["require", "exports", "module", "ace/lib/dom"], (acequire, exports) => {
  exports.isDark = false;
  exports.cssClass = "ace-queryinput";
  const dom = acequire("../lib/dom");
  dom.importCssString(exports.cssText, exports.cssClass);
});
